import GiftWrapViewController from './GiftWrapViewController';

export default GiftWrapViewController;